// extracted by mini-css-extract-plugin
export default {"root":"ContainerBox_root__0GNO-"};